import { createApp } from "vue";
import { createPinia } from 'pinia';
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import vueLenisPlugin from 'lenis/vue'
import { createGtm } from "@gtm-support/vue-gtm"; 
import router from "./router";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faExpand,
  faPause,
  faPlay,
  faVolumeXmark,
  faVolumeHigh,
  faCirclePlay,
} from "@fortawesome/free-solid-svg-icons";
import App from "./App.vue";
import trackVideo from "./directives/trackVideo";

const app = createApp(App);
app.directive("track-video", trackVideo);

app.use(
  createGtm({
    id: "GTM-W8GV88",
    enabled: true,
    debug: false,
    queryParams: {},
    compatibility: false,
    nonce: "7S00aPbloS",
    vueRouter: router,
  })
);

// ✅ Add Font Awesome icons
library.add(
  faPause,
  faPlay,
  faVolumeXmark,
  faVolumeHigh,
  faExpand,
  faCirclePlay
);
app.component("font-awesome-icon", FontAwesomeIcon);

const vuetify = createVuetify({
  components,
  directives,
})

const pinia = createPinia();

app.use(router);
app.use(vuetify);

// Only register Lenis smooth scroll on desktop — it intercepts native touch scroll on mobile
if (!/Mobi|Android/i.test(navigator.userAgent)) {
  app.use(vueLenisPlugin);
}

app.use(pinia);

app.mount("#app");
